/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

import escapeRegExp from '../escapeRegExp';

/**
 * @private
 * Datetime formats.
 */
const defaults = {
  timeFormat: 'HH:mm', // settings.defaults.timeFormat
  dateFormat: 'MM/dd/yyyy', // settings.defaults.dateFormat
};

/**
 * @private
 * Datetime format flags.
 *
 * @type {RegExp}
 */
const DATETIME = /[dMyHhms]+/g;

/**
 * @private
 * Replaces every flag in a datetime format, to use instead a raw string to build a `RegExp` pattern.
 *
 * @param  {String} match: the text matched in the RegExp
 * @return {String}
 */
function replacer(match) {
  switch (match) {
    case 'yyyy':
      return '([1-2][0,9][0-9][0-9])';
    case 'MM':
      return '((0[1-9])|(1[0-2]))';
    case 'dd':
      return '((0[1-9])|([1-2][0-9])|(3[0-1]))';
    case 'HH':
      return '([0-1][0-9]|[2][0-3])';
    case 'hh':
      return '([0][0-9]|[1][0-2])';
    case 'mm':
      return '([0-5][0-9])';
    case 'ss':
      return '([0-5][0-9])';
  }
  return '';
}

/**
 * @private
 * Builds the string pattern used to build the `RegExp` object.
 *
 * @param  {String} format: raw string used to build the pattern in a RegExp
 * @return {String}
 */
function buildStringPattern(format) {
  format = escapeRegExp(format).replace(DATETIME, replacer);
  return `^${format}$`;
}

/**
 * @public
 * Built-in validator patterns.
 */
const PATTERNS = {
  // validates the date format according to regional setting
  date: new RegExp(buildStringPattern(defaults.dateFormat)),
  // validates the time format: HH:mm:ss
  time: (/^([0-1][0-9]|[2][0-3]):([0-5][0-9])(?::([0-5][0-9])){0,1}$/),
  // validates the date-time format according to regional setting
  datetime: new RegExp(buildStringPattern(`${defaults.dateFormat} ${defaults.timeFormat}`)),
  email: /^([\w-+]+(?:\.[\w-+]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?$)/i,
  url: /((?:http|ftp|https):\/\/[\w\-_]+(?:\.[\w\-_]+)+(?:[\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?)/gi,
  // validates the password strength (must have 8+ characters, 1+ number, 1+ uppercase)
  password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
  zipcode: /\d{5}/,
};

export default PATTERNS;
